(function () {
  function hydrateAfricaMap(container) {
    if (!container || container.dataset.boMapReady === 'true') return;

    var figure = container.querySelector('.bo-africa-map__figure');
    if (!figure) return;

    if (figure.querySelector('svg')) {
      container.dataset.boMapReady = 'true';
      return;
    }

    var src = container.getAttribute('data-map-src');
    if (!src) return;

    fetch(src)
      .then(function (response) {
        if (!response.ok) throw new Error('Map fetch failed');
        return response.text();
      })
      .then(function (markup) {
        if (!markup || markup.indexOf('<svg') === -1) throw new Error('Invalid map SVG');
        if (figure.querySelector('svg')) return;
        figure.innerHTML = markup.trim();
        container.dataset.boMapReady = 'true';
      })
      .catch(function () {
        var img = document.createElement('img');
        img.className = 'bo-africa-map__img';
        img.src = src;
        img.alt = '';
        img.width = 800;
        img.height = 900;
        img.loading = 'lazy';
        img.decoding = 'async';
        figure.appendChild(img);
        container.dataset.boMapReady = 'fallback';
      });
  }

  function hydrateAll(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-bo-africa-map]').forEach(hydrateAfricaMap);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      hydrateAll();
    });
  } else {
    hydrateAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    hydrateAll(event.target);
  });
})();
